import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, MaybeAsync, Resolve, RouterStateSnapshot } from "@angular/router";
import { ClientStateService } from "@shared/services/client-state.service";

@Injectable({
  providedIn: "root",
})
export class AuthStateResolver implements Resolve<void> {
  private readonly clientStateService = inject(ClientStateService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<void> {
    this.initializeAuthenticatedState();
  }

  private initializeAuthenticatedState(): void {
    this.clientStateService.initClientState();
  }
}
